import type { ColumnsArrayType } from '../common/columns'

export const stockColumns: ColumnsArrayType = [
  {
    key: 'tankName',
    label: 'TANK NAME',
    placeholder: '',
  },
  {
    key: 'group',
    label: 'GROUP*',
    placeholder: '',
  },
  {
    key: 'batchInput',
    label: 'BATCH*',
    placeholder: 'Enter batch name',
  },
  {
    key: 'count',
    label: 'COUNT*',
    placeholder: 'Enter number',
  },
  {
    key: 'moveDate',
    label: 'MOVE DATE*',
    placeholder: '',
  },
  {
    key: 'sampleWeight',
    label: 'SAMPLE WEIGHT',
    placeholder: 'Enter weight (g)',
  },
]

export default stockColumns
